import { TitlesEnum } from "../enums/TitlesEnum";
import sprsoBlueImage from "../images/sprso-blue.png";
import sprsoBrownImage from "../images/sprso-brown.png";
import sprsoGrayImage from "../images/sprso-gray.png";
import sprsoYellowImage from "../images/sprso-yellow.png";

export const getImage = (name: TitlesEnum): string | null => {
    switch (name) {
        case TitlesEnum.DARK_ROAST:
            return sprsoBrownImage;
        case TitlesEnum.PASTEL_BLOOM:
            return sprsoBlueImage;
        case TitlesEnum.WHITE_LATTE:
            return sprsoGrayImage;
        case TitlesEnum.BRIGHT_YELLOW:
            return sprsoYellowImage;
        default:
            return null;
    }
};
